module.exports = ".logout_sso {\n  margin: 150px auto;\n  text-align: center;\n/*border 1px solid red \n\t\n\th1, h2, h3\n\t\tfont-size 2.5em*/\n}\n@media (max-width: 640px) {\n  .logout_sso {\n    width: 100%;\n    padding: 0 10px;\n  }\n}\n@media (min-width: 768px) {\n  .logout_sso {\n    width: 50%;\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/logout/logoutsso.component.css
// module id = 479
// module chunks = 0